import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface DialogData {
  title: string;
  message: string;
  action: string;
}

@Component({
  selector: "vp-confirm",
  styleUrls: ["./confirmation-dialog.component.scss"],
  templateUrl: "./confirmation-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ConfirmationDialogComponent {
  data = inject<DialogData>(MAT_DIALOG_DATA);
}
